<div [ngSwitch]="role.userType" [attr.data-test-id]="'role'">
  <ng-container *ngSwitchCase="USER_TYPE_PATIENT">
    <app-role-patient [diseases]="patient.diseases"></app-role-patient>
  </ng-container>

  <ng-container *ngSwitchCase="USER_TYPE_DOCTOR">
    <app-role-doctor
      [specialtys]="doctor.specialty"
      [education]="doctor.education"
      [fellowship]="doctor.fellowship"
      [treatmentDiseases]="doctor.treatment_of_diseases"
      [organizationNames]="doctor.organization_which_represented"
    ></app-role-doctor>
  </ng-container>

  <ng-container *ngSwitchCase="USER_TYPE_MED_STAFF">
    <app-role-med-staff
      [specialtys]="medStaff.specialty"
      [education]="medStaff.education"
      [fellowship]="medStaff.fellowship"
      [treatmentDiseases]="medStaff.treatment_of_diseases"
      [organizationNames]="medStaff.organization_which_represented"
    ></app-role-med-staff>
  </ng-container>

  <ng-container *ngSwitchCase="USER_TYPE_RESEARCHER">
    <app-role-researcher
      [treatmentDiseases]="researcher.diseases"
      [specialtys]="researcher.specialty"
      [organizationNames]="researcher.organization_which_represented"
    ></app-role-researcher>
  </ng-container>

  <ng-container *ngSwitchCase="USER_TYPE_ORGANIZATION">
    <app-role-organization [content]="organization"></app-role-organization>
  </ng-container>
</div>
